var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurve1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 68,
    viewBox: "0 0 185 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.5 66C181.5 82.8 171.962 98.3412 155.874 109.82C139.794 121.294 117.399 128.5 92.5 128.5C67.6014 128.5 45.2062 121.294 29.1255 109.82C13.0378 98.3412 3.5 82.8 3.5 66C3.5 49.2 13.0378 33.6588 29.1255 22.1801C45.2062 10.7062 67.6014 3.5 92.5 3.5C117.399 3.5 139.794 10.7062 155.874 22.1801C171.962 33.6588 181.5 49.2 181.5 66Z",
    stroke: "#1F3549",
    strokeWidth: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurve1);
export default __webpack_public_path__ + "static/media/curve1.88d19e083bf24a139f79cea8c699f6a3.svg";
export { ForwardRef as ReactComponent };